import { Injectable } from '@angular/core';
import { User } from '@smartnowx/hcms-commons';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap, retry, catchError, mergeMap } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';
import { IConstants } from '../IConstants';

const API_ENDPOINT = "auth";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  login(user: User): Observable<User> {
    return this.http.post<User>(`${environment.HOST}${environment.API_PATH_PREFIX}${API_ENDPOINT}`, user)
      .pipe(
        retry(environment.API_RETRY),
        mergeMap((loggedInUser: User) => {
          if (loggedInUser.role && loggedInUser.role.rights && loggedInUser.role.rights.includes(environment.AUTHZ_PERMISSION_NAME)) {
            localStorage.setItem(IConstants.CONSTANT_AUTH_STORAGE_NAME, JSON.stringify(loggedInUser));
            return of(loggedInUser);
          } else {
            return throwError(() => new HttpErrorResponse({ status: 403, statusText: 'Forbidden' }));
          }
        })
      );
  }

  register(user: User): Observable<User> {
    return this.http.post<any>(`${environment.HOST}${environment.API_PATH_PREFIX}register`, user);
  }

  getUser(): User {
    return JSON.parse(localStorage.getItem(IConstants.CONSTANT_AUTH_STORAGE_NAME) || '{}') as User;
  }

  isLoggedIn(): boolean {
    return localStorage.getItem(IConstants.CONSTANT_AUTH_STORAGE_NAME) !== null;
  }

  logout(): void {
    localStorage.removeItem(IConstants.CONSTANT_AUTH_STORAGE_NAME);
  }
}